<template>
  <div>
    <b-table
        :busy="stockListLoading"
        :caption="
        current
          ? 'Seçili Cari : ' + current.name
          : 'Sepetinize ürün eklemek için cari seçimi yapınız.'
      "
        :fields="stockListHeaders.filter(item => item.visible)"
        :items="stockList"
        :per-page="perPage"
        caption-top
        class="table table-hover"
        hover
        responsive
        show-empty
        head-row-variant="info"
        table-variant="white"
    >
      <template #empty="scope">
        <h6 class="text-center my-5">
          {{ scope.loading ? "Lütfen Bekleyin" : noStockMessage }}
        </h6>
      </template>
      <template #cell(images)="data">
        <img
            v-if="findFirstImage(data.item.files).images"
            style="width: 75px; height: 75px"
            alt=""
            :src="findFirstImage(data.item.files).imageSource"
            @click="expandImage(findFirstImage(data.item.files).images)"
        />
        <img v-else style="height: 50px;width: 50px" src="@/assets/images/no_image2.jpg" alt="no_image">
      </template>
      <template #cell(code)="data">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
                style="cursor: pointer;"
                class="text-secondary font-size-12"
                v-bind="attrs"
                v-on="on"
                @click="openStockActionListDialog(data.item)"
            >
              {{ data.item.code }}
            </span>
          </template>
          <span>Stok Hareketlerini Görüntülemek İçin Tıklayın</span>
        </v-tooltip>
      </template>
      <template #cell(name)="data">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
                label
                small
                outlined
                v-bind="attrs"
                v-on="on"
                color="amber darken-4"
                @click="goProductDetail(data.item.code)"
            >
              {{ data.item.name }}
            </v-chip>
            <p class="mb-0" v-if="data.item.producerCode">
              Üretici Kodu :
              <span class="fw-medium">{{ data.item.producerCode }}</span>
            </p>
          </template>
          <span>Ürün Detayını Görmek İçin Tıklayın</span>
        </v-tooltip>
      </template>
      <template #cell(balance)="data">
        <span class="font-size-12" v-if="user.RoleGroupId !== '3'">{{ data.item.balance + " " + data.item.unit1 }}</span>
        <span class="font-size-12" v-if="user.RoleGroupId === '3' && data.item.stockStatus === 0">{{ data.item.numericStockBalance }}</span>
        <span class="font-size-12" v-if="user.RoleGroupId === '3' && data.item.stockStatus === 1"
              style="height: 15px; width: 15px; background-color: #04AA6B; border-radius: 50%; display: inline-block;"></span>
        <span class="font-size-12" v-if="user.RoleGroupId === '3' && data.item.stockStatus === 2"
              style="height: 15px; width: 15px; background-color: #DD1E34; border-radius: 50%; display: inline-block;"></span>
      </template>
      <template #cell(denominator1)="data">
        <span class="font-size-12">{{data.item.denominator1 + ' ' + data.item.unit1}}</span>
      </template>
      <template v-if="!user?.userInfo.priceIntervention || user.RoleGroupId === '3'" #cell(unitPrice)="data">
        <span class="font-size-12">{{ numberConverter(data.item.unitPrice) + fetchCurrencyLabel(data.item.currencyId) + ' '}}</span>
        <span>
        <v-tooltip bottom v-if="getPaymentMethodDiscounts">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small class="mb-1">mdi-information-outline</v-icon>
          </template>
          <div>Çek/Senet: {{numberConverter(data.item.unitPrice1)}}</div>
          <div>K.K 5 Taksit: {{numberConverter(data.item.unitPrice2)}}</div>
          <div>K.K Tek Çekim: {{numberConverter(data.item.unitPrice3)}}</div>
          <div>Havale/EFT: {{numberConverter(data.item.unitPrice4)}}</div>

        </v-tooltip>
        </span>
      </template>
      <template v-else #cell(unitPrice)="data">
        <div class="d-flex align-items-center justify-center ">
          <input
              type="text"
              v-model="data.item.unitPrice"
              :key="data.item.code"
              :min="0.01"
              step="0.01"
              inputmode="numeric"
              pattern="[0-9]*[.,]?[0-9]+"
              style="width: 60px; height: 32px; margin-right: 5px"
              class="form-control form-control-sm text-right font-size-12"
          />
          <span>{{ fetchCurrencyLabel(data.item.currencyId)  }}</span>
        </div>
      </template>
      <template #cell(discountUnitPrice)="data">
        <span class="font-size-12">{{ numberConverter(data.item.discountUnitPrice) + fetchCurrencyLabel(data.item.currencyId)  }}</span>
      </template>
      <template #cell(discount1)="data">
        <div class="d-flex justify-center font-size-12">
          <input
              v-if="user.RoleGroupId === '1' || user.userInfo.discountIntervention && user.RoleGroupId !== '3'"
              type="number"
              v-model="data.item.discount1"
              :key="data.item.code"
              :min="1"
              style="width: 60px; height: 32px"
              class="form-control form-control-sm text-right"
              :disabled="user.RoleGroupId ==='3'"
          />
          <span v-else>{{ data.item.discount1 }}</span>
        </div>
      </template>
      <template #cell(discount2)="data">
        <div class="d-flex justify-center">
          <input
              v-if="user.RoleGroupId === '1' || user.userInfo.discountIntervention && user.RoleGroupId !== '3'"
              type="number"
              v-model="data.item.discount2"
              :key="data.item.code"
              :min="1"
              class="form-control form-control-sm text-right"
              style="width: 60px; height: 32px"
              :disabled="user.RoleGroupId ==='3'"
          />
          <span v-else>{{ data.item.discount2 }}</span>
        </div>
      </template>
      <template #cell(amount)="data">
        <div class="d-flex justify-center">
          <input
              v-model="data.item.quantity"
              type="number"
              :min="1"
              class="form-control form-control-sm"
              style="width: 60px; height: 32px"
              @keydown.enter.prevent="e => addToCart(data.item, data.item.quantity)"
              @change="e => (data.item.quantity = e.target.value)"
              v-if="
              cartList.filter(e => e.stockCode === data.item.code).length < 1
            "
          />
          <input
              v-if="cartList.filter(e => e.stockCode === data.item.code).length > 0"
              type="number"
              :value="cartList.find(e => e.stockCode === data.item.code).quantity"
              :min="1"
              class="form-control form-control-sm text-right"
              style="width: 60px; height: 32px"
              @keydown.enter.prevent="e => addToCart(data.item, e.target.value)"
              @change="e => (data.item.quantity = e.target.value)"
          />
<!--          <v-select :items=[data.item.unit1,data.item.unit2]></v-select>-->
        </div>
      </template>
<!--      <template #cell(units)="data">-->
<!--        <div class="d-flex justify-center">-->
<!--          <div v-if="data.item.units.length > 1" ><v-select v-model="data.item.selectedUnit" :items="data.item.units" hide-details solo dense style="max-width: 90px; font-size: medium;"></v-select></div>-->
<!--          <div v-else class="mt-3"> <h5>{{data.item.units[0].text}}</h5></div>-->
<!--        </div>-->
<!--      </template>-->
      <template #cell(processes)="data">
        <div class="d-flex" style="justify-content: center; align-items: center">
          <v-tooltip bottom v-if="
                  cartList.filter(e => e.stockCode === data.item.code).length <
                    1
                ">
            <template v-slot:activator="{on, attrs}">
              <v-btn
                  class="me-2"
                  small
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="success"
                  @click="addToCart(data.item, data.item.quantity)"
              >
                <v-icon> mdi-basket-plus</v-icon>
              </v-btn>
            </template>
              <span>Sepete Ekle</span>
          </v-tooltip>
          <v-tooltip
              bottom
              v-if="
              cartList.filter(e => e.stockCode === data.item.code).length > 0
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="success"
                  @click="addToCart(data.item, data.item.quantity)"
              >
                <v-icon>mdi-basket-plus</v-icon>
              </v-btn>
            </template>
            <span>Miktarı Değiştir</span>
          </v-tooltip>
          <v-tooltip
              bottom
              v-if="
              cartList.filter(e => e.stockCode === data.item.code).length > 0
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="danger"
                  @click="cartStockRemove(data.item)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Sepetten Çıkar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="!(data.item.warehouseBalances.length === 0 && data.item.branchBalances.length === 0)">
            <template v-slot:activator="{on, attrs}">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="openStockDetailDalog(data.item)"
              >
                <v-icon> mdi-warehouse</v-icon>
              </v-btn>
            </template>
            <span>Depo Bakiyeleri</span>
          </v-tooltip>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner
              variant="primary"
              size="lg"
              label="Text Centered"
          ></b-spinner>
        </div>
      </template>
    </b-table>
    <MuadilKodDialog
        :title="'Muadil Kod Düzenle'"
        :showDialog="muadilKodDialog"
        @dialogChange="e => (muadilKodDialog = e)"
        :product="muadilKodDialogData"
    ></MuadilKodDialog>
    <StokOzellikDialog
        :title="'Stok Özellikleri'"
        :showDialog="stokOzellikDialog"
        @dialogChange="e => (stokOzellikDialog = e)"
        :product="stokOzellikDialogData"
    ></StokOzellikDialog>
    <StockActionsDialog
        :showDialog="showStockActionsDialog"
        :stockCodeProp="stockCodeProp"
        :currentCodeProp="currentCodeProp"
        @dialogChange="e => (showStockActionsDialog = e)"
    >
    </StockActionsDialog>
    <ProductDetail
        :stock-code="productDetailStockCode"
        :showDialog="showProductDetailDialog"
        @dialogChange="e => (showProductDetailDialog = e)"
    ></ProductDetail>
    <StockDetailDialog
        :show-dialog="showStockDetailDailog"
        @dialogChange="e => (showStockDetailDailog = e)"
        :stockData="stockDataProp"
    ></StockDetailDialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {mapState, mapActions, mapMutations, mapGetters} from "vuex";
import MuadilKodDialog from "@/components/product-search/dialogs/MuadilKodDialog.vue";
import StokOzellikDialog from "@/components/product-search/dialogs/StokOzellikDialog.vue";
import StockActionsDialog from "@/components/product-search/dialogs/StockActionsDialog";
import ProductDetail from "@/pages/views/product/ProductDetail.vue";
import StockDetailDialog from "@/components/product-search/dialogs/StockDetailDialog.vue";
import {numberConverter} from "../../../../helpers";
import {showProcessErrorMessage} from "@/state/alertHelpers";

export default {
  components: {
    ProductDetail,
    MuadilKodDialog,
    StokOzellikDialog,
    StockActionsDialog,
    StockDetailDialog,
  },
  props: {
    perPage: {
      type: Number
    },
    currentPage: {
      type: Number
    }
  },

  computed: {
    ...mapState("stock", ["stockList", "stockListHeaders", "stockListLoading", "noStockMessage"]),
    ...mapState("cart", ["cartList", "current", "cartListMetaData"]),
    ...mapState("auth", ["user"]),
    ...mapGetters("settings",["getPaymentMethodDiscounts","getCurrencyLabels"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
  },
  data() {
    return {
      on: {},
      attrs: {},
      showProductDetailDialog: false,
      showStockDetailDailog: false,
      productDetailStockCode: null,
      muadilKodDialog: false,
      muadilKodDialogData: null,
      stokOzellikDialog: false,
      stokOzellikDialogData: null,
      showStockActionsDialog: false,
      stockCodeProp: null,
      currentCodeProp: null,
      tableColumnSelectDialog: false,
      stockSearchTableKey: 0,
      stockAmount: 1,
      stockDataProp: null,
      // isDiscountExceeded: false,
    };
  },
  mounted() {
  },
  methods: {
    numberConverter,
    ...mapActions("cart", [
      "addProductToCartList",
      "removeProductFromCartList",
      "changeQuantityOfProduct",
      "stockToCartAdd",
      "cartStockUpdate",
      "fetchSingleCartList",
      "cartStockDelete"
    ]),
    ...mapActions("stock", ["fetchStockImage"]),

    ...mapMutations("stock", ["setStockListHeadersPreset"]),
    findFirstImage(item) {
      let imageSource = null;
      let images = null;
      let imageTypes = ['jpeg', 'jpg', 'gif', 'png',"webp","svg","JPEG","JPG","GIF","PNG","WEBP","SVG","bmp","BMP","tiff","TIFF","ico","ICO","svgz","SVGZ","heif","HEIF","heic","HEIC","avif","AVIF","apng","APNG","jfif","JFIF","pjpeg","PJPEG","pjp","PJP","avif","AVIF","avifs","AVIFS"];
      if (item) {
        let allImages = item.filter((item) => imageTypes.some(type => item.fileUrl.includes(type)));
        images = allImages.map((e) => e.fileUrl)
        imageSource = allImages[0].fileUrl
      }
      return {imageSource, images}
    },
    async addToCart(product, quantity = 1) {
      // quantity = product.selectedUnit * product.denominator1;
      // if (product.selectedUnit === 2 || product.selectedUnit === '2') {
      //   quantity = product.denominator1 * quantity;
      // }
      // if (product.discount1 > product.maxDiscount) this.isDiscountExceeded = true; else this.isDiscountExceeded = false;
      // product;
      if (quantity <= 0) {
        showProcessErrorMessage({
          title: "Ürün Ekleme Başarısız",
          text: "Miktar sıfırdan büyük olmalıdır",
          icon: "error",
          confirmButtonText: "Tamam"
        })
        return;
      }
      if (product.discount1 < 0 || product.discount2 < 0) {
        showProcessErrorMessage({
          title: "Ürün Ekleme Başarısız",
          text: "İndirim oranı sıfırdan büyük olmalıdır",
          icon: "error",
          confirmButtonText: "Tamam"
        })
        return;
      }
      if (!this.current) {
        await Swal.fire({
          title: "Ürün Ekleme Başarısız",
          text: "Cari listesinden cari seçimi yapmalısınız",
          icon: "error",
          confirmButtonText: "Tamam"
        });
      } else {
        if (this.user.userInfo.priceIntervention) {
          let originalPrice = null;
          if (typeof (product.unitPrice) === "string") {
            originalPrice = product.unitPrice.replace('.', '').replace(',', '.');
            originalPrice = parseFloat(originalPrice);
          } else {
            originalPrice = product.unitPrice
          }


          await this.stockToCartAdd({
            params: {
              userId: this.user.UserId,
              currentCode: this.current.code
            },
            body: {
              StockCode: product.code,
              Quantity: quantity,
              Unit: 1,
              Discount1: product.discount1,
              Discount2: product.discount2,
              isBasket: false,
              Description: null,
              UnitPrice: originalPrice,
              // isDiscountExceeded: this.isDiscountExceeded,
            }
          });
        } else {
          await this.stockToCartAdd({
            params: {
              userId: this.user.UserId,
              currentCode: this.current.code
            },
            body: {
              StockCode: product.code,
              Quantity: quantity,
              Unit: 1,
              Discount1: product.discount1,
              Discount2: product.discount2,
              isBasket: false,
              Description: null,
              // isDiscountExceeded: this.isDiscountExceeded,
            }
          });
        }
        this.stockAmount = 1;
      }
    },
    async cartStockChange(product, quantity = 1) {
      if (!this.current) {
        Swal.fire({
          title: "Ürün Adet Güncelleme Başarısız",
          text: "Cari listesinden cari seçimi yapmalısınız",
          icon: "error",
          confirmButtonText: "Tamam"
        });
      } else {
        if (this.user.userInfo.priceIntervention) {
          await this.cartStockUpdate({
            params: {
              userId: this.user.UserId,
              currentCode: this.current.code
            },
            body: {
              Id: product.id,
              StockCode: product.stockCode,
              Quantity: quantity,
              Discount1: product.discount1, //Neye karşılık geliyor ?
              Discount2: product.discount2, //Neye karşılık geliyor ?
              Unit: 1,
              UnitPrice: product.unitPrice,
            }
          });
        } else {
          await this.cartStockUpdate({
            params: {
              userId: this.user.UserId,
              currentCode: this.current.code
            },
            body: {
              Id: product.id,
              StockCode: product.stockCode,
              Quantity: quantity,
              Discount1: product.discount1, //Neye karşılık geliyor ?
              Discount2: product.discount2, //Neye karşılık geliyor ?
              Unit: 1,
            }
          });
        }
      }
    },
    async cartStockRemove(product) {
      await this.cartStockDelete({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          stockCode: product.code
          //basketCode: null //sepet Kodu ise yollanacak
        },
        body: {}
      });
    },
    expandImage(images) {
      this.$viewerApi({
        images: images,
      });
    },
    openMuadilKodDialog(data) {
      this.muadilKodDialogData = data;
      this.muadilKodDialog = true;
    },
    openStokOzellikDialog(data) {
      this.stokOzellikDialogData = data;
      this.stokOzellikDialog = true;
    },
    openStockActionListDialog(data) {
      this.stockCodeProp = data.code;
      //this.currentCodeProp = data.currentCode;
      this.showStockActionsDialog = true;
    },
    goProductDetail(stockCode) {
      this.showProductDetailDialog = true;
      this.productDetailStockCode = stockCode;
    },
    editTableColumns(cols = []) {
      this.setStockListHeadersPreset(cols);
    },
    async stockImageList(item) {
      let imagePathArray = [];

      for (let i = 1; i < 6; i++) {
        imagePathArray[i - 1] = item['imagePath' + i];
      }
      return imagePathArray;
    },
    openStockDetailDalog(data) {
      this.stockDataProp = data;
      this.showStockDetailDailog = true;
    },
    // @change="e => compareDiscount(data.item, data.item.discount1)"
    // compareDiscount(e, e2) {
    //   if (e.maxDiscount < e2) {
    //     showProcessErrorMessage({
    //       title: 'Uyarı',
    //       text: "Girilen indirim oranı, kampanya indirim oranından büyük. Sipariş yönetici onayına gidecektir."
    //     })
    //   }
    // }
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '₺';
    },
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input {
  border: none;
  outline: none;
//background-color: #f2f2f2; padding: 10px; border-radius: 5px; box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); transition: background-color 0.3s, box-shadow 0.3s; color: #333; font-size: 12px; font-family: Arial, sans-serif;
}

input:hover {
//background-color: #e0e0e0; box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
}

input:focus {
//background-color: #f2f2f2; box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}
</style>
